import React from 'react';
import { GridCellParams } from '@mui/x-data-grid';
import { missingField } from 'app/constants';
import { getNumberFormattedValue } from '../../ModificationsUtils';

export const CostToTravelerComponent = React.memo(function CostToTravelerComponent(cellParams: any) {
  const value = getNumberFormattedValue(cellParams?.row?.costToTraveler);
  return (
    <div>
      <span>{value === missingField || value === null || value === '' ? missingField : `$${value}`}</span>
    </div>
  );
});

export const CostToTraveler = (params: GridCellParams) => {
  return <CostToTravelerComponent {...params} />;
};
